import React, { forwardRef } from "react";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";

const Textarea = forwardRef(
  (
    {
      label = "",
      labelClassName = "",
      textareaClassName = "",
      containerClassName = "",
      error = "",
      errorMessageClassName = "",
      labelPosition = "top",
      ...rest
    },
    ref
  ) => {
    const containerClasses = `form_element_wrapper_text ${labelPosition} ${containerClassName}`.trim();
    const textareaClasses = `builder_textarea ${textareaClassName} ${error ? "builder_error_textarea" : ""}`.trim();

    return (
      <div className={containerClasses}>
        {label && <Label className={labelClassName}>{label}</Label>}
        <textarea ref={ref} className={textareaClasses} {...rest} />
        {error && <ErrorMessage className={errorMessageClassName}>{error}</ErrorMessage>}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;
